/* eslint-disable import/no-unresolved */
import {
  KlevuEvents,
  KlevuKMCSettings,
} from 'https://cdn.skypack.dev/pin/@klevu/core@v1.1.5-0q1n6dBIy9DgOZifPmpX/mode=imports,min/optimized/@klevu/core.js'
/* eslint-enable import/no-unresolved */

const { productCardCache } = window.BAO.Caches
const { SearchResultsQuery } = window.BAO.Search.components
const { translateString } = window.BAO.Utils

class SearchPopularSearches extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['list', 'item-template']
  }

  connectedCallback () {
    super.connectedCallback()

    this.render()
  }

  async render () {
    const popularSearches = await this.getPopularSearches()

    this.setAttribute('aria-hidden', popularSearches.length === 0)

    const items = popularSearches.map(search => {
      const item = this.els['item-template'].element.content.cloneNode(true)
      const link = item.querySelector(
        '[data-search-popular-searches-el="link"]',
      )

      const url = new URL(window.location.origin)
      url.pathname = this.getAttribute('root-url')
      url.searchParams.set('q', search)

      link.href = `${url.pathname}${url.search}`
      link.textContent = search

      return item
    })

    this.els.list.element.append(...items)
  }

  /** @returns {Promise<string[]>} */
  async getPopularSearches () {
    const userSettings = await KlevuKMCSettings()

    return userSettings.root.klevu_webstorePopularTerms || []
  }
}

if (!customElements.get('search-popular-searches')) {
  customElements.define('search-popular-searches', SearchPopularSearches)
}

class SearchRecentSearches extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['list', 'item-template']
  }

  connectedCallback () {
    super.connectedCallback()

    this.render()
  }

  render () {
    if (this.recentSearches.length === 0) {
      return
    }

    this.setAttribute('aria-hidden', false)

    const items = this.recentSearches.map(recentSearch => {
      const item = this.els['item-template'].element.content.cloneNode(true)
      const link = item.querySelector('[data-search-recent-searches-link]')

      const url = new URL(window.location.origin)
      url.pathname = this.getAttribute('root-url')
      url.searchParams.set('q', recentSearch)

      link.href = `${url.pathname}${url.search}`
      link.textContent = recentSearch

      return item
    })

    this.els.list.element.append(...items)
  }

  /** @returns {string[]} */
  get recentSearches () {
    const defaultValue = []
    const recentSearches = window.localStorage.getItem(
      'search-results:recent-searches',
    )

    if (!recentSearches) {
      return defaultValue
    }

    try {
      const value = JSON.parse(recentSearches)
      return value
    } catch (error) {
      return []
    }
  }
}

if (!customElements.get('search-recent-searches')) {
  customElements.define('search-recent-searches', SearchRecentSearches)
}

class SearchResultsCategory extends SearchResultsQuery {
  static get requiredElements () {
    return ['list', 'item-template']
  }

  render ({ records }) {
    this.setAttribute('aria-hidden', records.length === 0)

    const listItems = records.map(record => {
      const listItem = this.els['item-template'].element.content.cloneNode(true)
      const link = listItem.querySelector(
        '[data-search-results-category-el="link"]',
      )
      const url = new URL(record.url)

      link.href = url.pathname
      link.innerHTML = record.name

      return listItem
    })

    this.els.list.element.replaceChildren(...listItems)
  }
}

if (!customElements.get('search-results-category')) {
  customElements.define('search-results-category', SearchResultsCategory)
}

class SearchResultsProducts extends SearchResultsQuery {
  static get requiredElements () {
    return ['list', 'item-template']
  }

  async render ({ meta, records }) {
    const url = new URL(window.location.origin)
    url.pathname = '/search'
    url.searchParams.set('q', meta.searchedTerm)

    const header = this.els['header-link']
    if (header) {
      header.element.href = `${url.pathname}${url.search}`
    }

    const title = this.els.title
    if (title) {
      this.els.title.element.textContent = translateString(
        this.dataset.titleTemplate,
        { count: meta.totalResultsFound },
      )
    }

    const productCards = await Promise.all(
      records.map(record => {
        const handle = new URL(record.url).pathname.replace(/^\/products\//, '')

        return productCardCache.get(handle)
      }),
    )

    const listItems = productCards.map((productCard, index) => {
      const listItem = this.els['item-template'].element.content.cloneNode(true)
      const item = listItem.querySelector(
        '[data-search-results-products-el="item"]',
      )

      item.innerHTML = productCard

      const record = records[index]
      const card = item.querySelector('.prd-Card')
      card.addEventListener('click', () =>
        KlevuEvents.searchProductClick(record, meta.searchedTerm),
      )

      return listItem
    })

    this.els.list.element.replaceChildren(...listItems)
  }
}

if (!customElements.get('search-results-products')) {
  customElements.define('search-results-products', SearchResultsProducts)
}

class SearchResultsMessage extends window.BAO.CustomElement() {
  /** @param {{ query: string; }} */
  render ({ query }) {
    this.textContent = translateString(this.dataset.template, { query })
  }
}

if (!customElements.get('search-results-message')) {
  customElements.define('search-results-message', SearchResultsMessage)
}
